import React from "react";
import Box from "@mui/material/Box";
import { BarChart } from "@mui/x-charts/BarChart";

export default function SiteBarChart({ data = [] }) {
  const sites = data.map((item) => item.site);
  const counts = data.map((item) => item.sample_count);

  return (
    <Box>
      <BarChart
        xAxis={[{ data: sites, label: "Site", scaleType: "band" }]}
        series={[{ data: counts, label: "Count", color: "#5AC1EF" }]}
        height={185}
        width={400}
        grid={{ vertical: true }}
        margin={{ left: 75, right: 0, top: 20, bottom: 60 }}
        slotProps={{
          legend: {
            hidden: true,
          },
        }}
      />
    </Box>
  );
}
